import React, { Component } from "react";
import { List } from "../transactions/nfoAndNewPurchase";
import Signbutton from "../../forms/button";
import Paper from "@material-ui/core/Paper";
import { connect } from "react-redux";
import { Input } from "../../forms/input";
import DateFnsUtils from "@date-io/date-fns";

import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from "@material-ui/pickers";
import { getcaptialgainStatment } from "../../../store/actions/mailback";

import CustomizedDialogs from "../../home/customModal";
import "react-datepicker/dist/react-datepicker.css";

import { formatDate } from "../../forms/captalize";
import { MailBackBreadCrumb } from "./mailBack";
import { DASHBOARD_URL } from "../dashboard";

class CGS extends Component {
  constructor(props) {
    super(props);
    this.state = {
      startDate: {
        value: null,
        error: "",
      },
      endDate: { value: null, error: "" },
      ConfirmSelfPassword: { value: "" },
      selfPassword: { value: "" },
      email: { value: "" },
      open: false,
      showPassword: false,
      confirmShowPassword: false,
    };
  }

  handleChangeSelfPassword = (event) => {
    this.setState({
      selfPassword: { value: event.target.value },
    });
  };
  handleChangeConfirmSelfPassword = (event) => {
    this.setState({
      ConfirmSelfPassword: { value: event.target.value },
    });
  };
  handleChangeEmail = (event) => {
    this.setState({
      email: { value: event.target.value },
    });
  };

  showError = (label) => (event) => {
    const {
      [label]: { value },
    } = this.state;

    if (label === "selfPassword") {
      if (
        this.state.selfPassword.value === "" ||
        !/^(?=.*?[A-Z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$/.test(
          this.state.selfPassword.value
        )
      ) {
        if (
          !/^(?=.*?[A-Z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$/.test(
            this.state.selfPassword.value
          )
        ) {
          this.setState({
            selfPassword: {
              isError: true,
              errorMessage: `Password should be atleast 8 characters in length and should contain at least 1 Upper Case alphabet(A-Z).1 Special Character and 1 Numeric Value (0-9)`,
            },
          });
          return;
        }
      } else if (this.state.selfPassword.value === "") {
        this.setState({
          selfPassword: {
            value: "",
            isError: true,
            errorMessage: `Password is mandatory`,
          },
        });
        return;
      }
    } else if (label === "email") {
      this.setState({
        [label]: {
          value,
          isError:
            /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/.test(
              this.state.email.value
            ) === false
              ? true
              : !value,
          errorMessage:
            /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/.test(
              this.state.email.value
            ) === false
              ? `Enter an vaild Email ID`
              : "",
        },
      });
    } else if (label === "ConfirmSelfPassword") {
      this.setState({
        [label]: {
          value,
          isError:
            this.state.selfPassword.value !==
              this.state.ConfirmSelfPassword.value ||
            this.state.ConfirmSelfPassword.value === ""
              ? true
              : !value,
          errorMessage:
            this.state.selfPassword.value !==
              this.state.ConfirmSelfPassword.value ||
            this.state.ConfirmSelfPassword.value === ""
              ? `The Password and Confirm Password do not match`
              : "",
        },
      });
    } else {
      this.setState({
        [label]: {
          value,
          isError: !value,
        },
      });
    }
  };
  closeYesModal = () => {
    this.setState({
      startDate: {
        value: new Date(),
        error: "",
      },
      endDate: { value: new Date(), error: "" },
      ConfirmSelfPassword: { value: "" },
      selfPassword: { value: "" },
      email: { value: "" },
      open: false,
    });
    this.props.history.replace(DASHBOARD_URL);
  };
  closeNoModal = () => {
    this.setState({
      open: false,
    });
    this.props.history.replace("/");
  };

  onDateChange = (label, event) => {
    if (label === "endDate" && !!this.state.startDate.value && !!event) {
      const reformtStDt = this.state.startDate.value.toLocaleDateString(
        "en-US",
        {
          month: "2-digit",
          year: "numeric",
          day: "2-digit",
        }
      );

      const changeEndDt = event.toLocaleDateString("en-US", {
        month: "2-digit",
        year: "numeric",
        day: "2-digit",
      });

      const d2 = new Date(reformtStDt).setHours(12, 0, 0, 0);
      const d3 = new Date(changeEndDt).setHours(12, 0, 0, 0);
      if (d2 > d3) {
        this.setState({
          [label]: {
            value: null,
            error: true,
            errorMessage: "Start date should be earlier than End date",
          },
        });
      } else {
        this.setState({
          [label]: { value: event, errorMessage: "", error: false },
        });
      }
    } else if (label === "startDate") {
      this.setState({
        [label]: { value: event },
        endDate: { value: null, error: "", errorMessage: "" },
      });
    }
  };

  submit = async () => {
    let startDateValue, endDateValue;

    if (this.state.startDate.value) {
      startDateValue = this.state.startDate.value.toLocaleDateString("en-US", {
        month: "2-digit",
        year: "numeric",
        day: "2-digit",
      });
    }
    if (this.state.endDate.value) {
      endDateValue = this.state.endDate.value.toLocaleDateString("en-US", {
        month: "2-digit",
        year: "numeric",
        day: "2-digit",
      });
    }

    const d2 = new Date(this.state.startDate.value).setHours(12, 0, 0, 0);
    const d3 = new Date(this.state.endDate.value).setHours(12, 0, 0, 0);

    const {
      AsDate,
      startDate,
      endDate,
      ConfirmSelfPassword,
      selfPassword,
      showPassword,
      confirmShowPassword,
      email,
      ...others
    } = this.state;

    if (
      !this.state.selfPassword.value ||
      !this.state.ConfirmSelfPassword.value ||
      !this.state.email.value ||
      !/^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/.test(
        this.state.email.value
      ) ||
      !/^(?=.*?[A-Z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$/.test(
        this.state.selfPassword.value
      ) ||
      !/^(?=.*?[A-Z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$/.test(
        this.state.ConfirmSelfPassword.value
      ) ||
      this.state.selfPassword.value !== this.state.ConfirmSelfPassword.value
    ) {
      if (
        !/^(?=.*?[A-Z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$/.test(
          this.state.selfPassword.value
        )
      ) {
        this.setState({
          selfPassword: {
            value: "",
            isShowPasswordError: true,
          },
        });
      }
      if (
        !/^(?=.*?[A-Z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$/.test(
          this.state.ConfirmSelfPassword.value
        )
      ) {
        this.setState({
          ConfirmSelfPassword: {
            value: "",
            isShowPasswordError: true,
          },
        });
      }
      if (!this.state.selfPassword.value) {
        this.setState({
          selfPassword: {
            value: "",
            isError: true,
            errorMessage: `Self-password is mandatory`,
          },
        });
      }
      if (!this.state.ConfirmSelfPassword.value) {
        this.setState({
          ConfirmSelfPassword: {
            value: "",
            isError: true,
            errorMessage: `Confirm Self-password is mandatory`,
          },
        });
      }
      if (
        !this.state.email.value ||
        !/^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/.test(
          this.state.email.value
        )
      ) {
        if (!this.state.email.value) {
          this.setState({
            email: {
              value: "",
              isError: true,
              errorMessage:`Please enter an Email id`,
            },
          });
        } else {
          this.setState({
            email: {
              value: "",
              isError: true,
              errorMessage: `Please enter a valid Email ID`,
            },
          });
        }
      }
      if (
        !!this.state.ConfirmSelfPassword &&
        !!this.state.selfPassword &&
        this.state.selfPassword.value !== this.state.ConfirmSelfPassword.value
      ) {
        this.setState({
          ConfirmSelfPassword: {
            value: "",
            isError: true,
            errorMessage: `The Password and Confirm Password do not match`,
          },
        });
      }
    } else if (!this.state.startDate.value) {
      this.setState({
        startDate: {
          value: null,
          error: true,
          errorMessage: "Start date is mandatory",
        },
      });
      return;
    } else if (!this.state.endDate.value) {
      this.setState({
        endDate: {
          value: null,
          error: true,
          errorMessage: "End date is mandatory",
        },
      });
      return;
    } else if (d2 > d3) {
      this.setState({
        startDate: {
          value: null,
          error: true,
          errorMessage: "Start date should be earlier than End date)",
        },
      });
    } else {
      const { investorData } = this.props;
      const params = {
        fromdt: formatDate(this.state.startDate.value),
        todate: formatDate(this.state.endDate.value),
        customfund: "189",
        trtype: "WBCAP",
        PAN: !!investorData && !!investorData.PAN ? investorData.PAN : "",
        Email: this.state.email.value,
        distCode: this.props.token,
        Password: this.state.selfPassword.value,
        distUid: this.props.userId,
      };

      const response = await this.props.getcaptialgainStatment(params);

      if (response) {
        this.setState({
          open: true,
        });
      }
    }
  };

  render() {
    const { investorData } = this.props;
    const { selfPassword, ConfirmSelfPassword, email } = this.state;
    return (
      <div style={{ marginTop: 30 }}>
        <MailBackBreadCrumb
          history={this.props.history}
          investorData={this.props.investorData}
          name="Capital Gains Account Statement"
        />
        <Paper
          className="digital-form-container"
          style={{ boxShadow: "0px 0px 2px 0px lightgray", marginTop: 20 }}
        >
          <div className="digital-form-left-div">
            <List investorData={investorData} />
          </div>
          <div className="digital-form-Right-div">
            <div className="transaction-details">
              <div className="title">Capital Gains Account Statement</div>
              <div className="input-margin">
                <Input
                  name="Email ID"
                  onChange={this.handleChangeEmail}
                  value={email.value}
                  bordercolor="#a6a6a6"
                  onBlur={this.showError("email")}
                  isShowError={email.isError}
                  errorMessage={email.errorMessage}
                />
              </div>
              <div className="input-margin">
                <div
                  className="simple-display-card-name"
                  style={{ marginBottom: 10 }}
                >
                  Start Date
                </div>
                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                  <KeyboardDatePicker
                    InputProps={{ readOnly: true }}
                    required={true}
                    className="selects"
                    style={{
                      margin: "0px 0px 20px 0px",
                      border: !!this.state.startDate.error
                        ? "1px solid red"
                        : "none",
                      borderTop: !!this.state.startDate.error
                        ? "2px solid red"
                        : "none",
                      borderRadius: !!this.state.startDate.error ? 7 : 0,
                    }}
                    onChange={(e) => this.onDateChange("startDate", e)}
                    // openTo={true}
                    disableFuture={true}
                    format="dd/MM/yyyy"
                    maxDate={new Date()}
                    id="mui-pickers-date"
                    value={this.state.startDate.value}
                  />
                  {!!this.state.startDate.errorMessage ? (
                    <div
                      style={{ color: "red", fontFamily: "Rubik-Italic" }}
                    >
                      {this.state.startDate.errorMessage}
                    </div>
                  ) : (
                    ""
                  )}
                </MuiPickersUtilsProvider>
              </div>
              <div className="input-margin">
                <div
                  className="simple-display-card-name"
                  style={{ marginBottom: 10 }}
                >
                  End Date
                </div>
                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                  <KeyboardDatePicker
                    InputProps={{ readOnly: true }}
                    required={true}
                    className="selects"
                    style={{
                      // margin: "0px 0px 20px 0px",
                      border: !!this.state.endDate.error
                        ? "1px solid red"
                        : "none",
                      borderTop: !!this.state.endDate.error
                        ? "2px solid red"
                        : "none",
                      borderRadius: !!this.state.endDate.error ? "7px" : 0,
                    }}
                    onChange={(e) => this.onDateChange("endDate", e)}
                    disabled={!this.state.startDate.value ? true : false}
                    disableFuture={true}
                    format="dd/MM/yyyy"
                    errorMessage={this.state.endDate.errorMessage}
                    maxDate={new Date()}
                    id="mui-pickers-date"
                    value={this.state.endDate.value}
                  />
                  {!!this.state.endDate.errorMessage ? (
                    <div
                      style={{ color: "red", fontFamily: "Rubik-Italic" }}
                    >
                      {this.state.endDate.errorMessage}
                    </div>
                  ) : (
                    ""
                  )}
                </MuiPickersUtilsProvider>
              </div>
              <div className="input-margin">
                <Input
                  name="Self Extraction Password"
                  bordercolor="#a6a6a6"
                  isShowPasswordError={
                    this.state.selfPassword.isShowPasswordError
                  }
                  type={!!this.state.showPassword ? "text" : "password"}
                  image={"/images/locked.svg"}
                  image2={
                    !!this.state.showPassword
                      ? "/images/Bajaj_eye.svg"
                      : "/images/Bajaj_eye_hide.svg"
                  }
                  onClick={() => {
                    this.setState({
                      showPassword: !this.state.showPassword,
                    });
                  }}
                  onChange={this.handleChangeSelfPassword}
                  value={selfPassword.value}
                  onBlur={this.showError("selfPassword")}
                  isShowError={selfPassword.isError}
                  errorMessage={selfPassword.errorMessage}
                />
              </div>
              <div className="input-margin">
                <Input
                  name="Confirm Self Extraction Password"
                  bordercolor="#a6a6a6"
                  isShowPasswordError={
                    this.state.ConfirmSelfPassword.isShowPasswordError
                  }
                  type={!!this.state.confirmShowPassword ? "text" : "password"}
                  image={"/images/locked.svg"}
                  image2={
                    !!this.state.confirmShowPassword
                      ? "/images/Bajaj_eye.svg"
                      : "/images/Bajaj_eye_hide.svg"
                  }
                  onClick={() => {
                    this.setState({
                      confirmShowPassword: !this.state.confirmShowPassword,
                    });
                  }}
                  height={!!this.state.confirmShowPassword ? 10 : 15}
                  onChange={this.handleChangeConfirmSelfPassword}
                  value={ConfirmSelfPassword.value}
                  onBlur={this.showError("ConfirmSelfPassword")}
                  isShowError={ConfirmSelfPassword.isError}
                  errorMessage={ConfirmSelfPassword.errorMessage}
                />
              </div>
              <div className="digital-form-button-next-div">
                <Signbutton buttontitle="Submit" onClick={this.submit} />
              </div>
               
              <CustomizedDialogs
                cas={true}
                open={this.state.open}
                closeYesModal={this.closeYesModal}
              />
            </div>
          </div>
        </Paper>
      </div>
    );
  }
}

export default connect(
  ({ authReducer }) => {
    const { investorData, userId, token } = authReducer;
    return { investorData, userId, token };
  },
  { getcaptialgainStatment }
)(CGS);
